import type { DynamicInvoiceMeasurementChartMeter } from '@weft/api-definition';
import type { LineItemProductVariant } from '@weft/types';
import { Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useDynamicInvoice } from '../dynamic-invoice-context';
import { buildPerUnitChartData, 
  getChartLabels } from '../dynamic-invoice-usage-line-item-chart-utils';
import { usageLineItemBarChartOptions } from '../dynamic-invoice-view-page-consts/dynamic-invoice-usage-line-item-bar-chart-options';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

type UsagePerUnitLineItemBarChartProps = {
  perUnitLineItemProductVariants: LineItemProductVariant[];
  productMetersMeasurementData: DynamicInvoiceMeasurementChartMeter
  selectedInstanceKeyValue?: string;
};

export const UsagePerUnitLineItemBarChart:React.FC<UsagePerUnitLineItemBarChartProps> = ({
  perUnitLineItemProductVariants,
  productMetersMeasurementData,
  selectedInstanceKeyValue,
}) => {
  const { dynamicInvoiceData: { invoice } } = useDynamicInvoice();
  const { billingCycle } = invoice;

  const chartLabels = getChartLabels(billingCycle);
  const data = buildPerUnitChartData(chartLabels, productMetersMeasurementData, perUnitLineItemProductVariants, billingCycle, selectedInstanceKeyValue);

  return (
    <div className="mb-1 mt-4 h-[358px] w-full">
      <Bar {...{ data, options: usageLineItemBarChartOptions }}/>
    </div>
  );
};